import { Pipe, PipeTransform } from '@angular/core';
import {LocalizeService} from '@services/helpers/localize/localize.service';

@Pipe({
    name: 'localizeText',
    standalone: true
})
export class LocalizeTextPipe implements PipeTransform {

  constructor(private localize: LocalizeService) {
  }

  transform(
    key: string,
    defaultOrParams?: string | any[] | Record<string, any> | null,
    ...restParams: any[]
  ): string {
    let fallback: string | null = null;
    let params: any[] | Record<string, any> | undefined;

    if (typeof defaultOrParams === 'string' || defaultOrParams == null) {
      fallback = defaultOrParams as string ?? null;
      params = restParams.length ? restParams : undefined;
    } else {
      // defaultOrParams is params; no explicit fallback provided
      params = defaultOrParams;
    }

    return this.localize.l(key, fallback, params);
  }
}
